import React, { useRef, useState } from "react";
import * as S from "./VideoWrapper.style";
import Separator from "../ui/Separator";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-light-svg-icons";
import { SVG } from "../ui/SVG";
import { SVGIcon } from "../ui/SVG/types";
// import LogoWhite from "~/assets/svg/smartli_white_logo.svg?react";
import LogoWhite from "~/assets/white-logo-v1.svg?react";
import { useMediaQuery } from "~/hooks/useMediaQuery";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { videos } from "~/constants/videos";

const VideoTutorialSection: React.FC = () => {
  const { t } = useTranslation();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isOverlayVisible, setIsOverlayVisible] = useState(true);
  const selectedTutorial = videos[selectedIndex];
  const isAboveTablet = useMediaQuery("tablet");

  const goPrev = () => {
    if (selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
      setIsOverlayVisible(true);
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  };

  const goNext = () => {
    if (selectedIndex < videos.length - 1) {
      setSelectedIndex(selectedIndex + 1);
      setIsOverlayVisible(true);
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  };

  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handlePlayClick = () => {
    setIsOverlayVisible(false);
  };

  const handleVideoChange = (index: number) => {
    setSelectedIndex(index);
    setIsOverlayVisible(true);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  return (
    <S.Container>
      <S.Title>{t("video.title")}</S.Title>

      <S.MobileWrapper>
        <S.VideoBox>
          {!isOverlayVisible && !isAboveTablet ? (
            <S.VideoPlayer
              autoPlay
              playsInline
              ref={videoRef}
              controls
              key={selectedTutorial.url}>
              <source src={selectedTutorial.url} type="video/mp4" />
              {t("ad_spy_tool.your_browser_does_not_support_video")}
            </S.VideoPlayer>
          ) : (
            <S.Thumbnail>
              <LogoWhite style={{ width: "200px", height: "100px" }} />
              <h1>{selectedTutorial.title}</h1>
            </S.Thumbnail>
          )}

          {isOverlayVisible && (
            <S.Overlay>
              <S.PlayButton onClick={handlePlayClick}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </S.PlayButton>
            </S.Overlay>
          )}
        </S.VideoBox>
        <S.MobileNav>
          <S.Arrow disabled={selectedIndex === 0} onClick={goPrev}>
            <SVG icon={faArrowLeft as SVGIcon} /> &nbsp;Previous
          </S.Arrow>
          <S.VideoTitle>{t(selectedTutorial.titleKey)}</S.VideoTitle>
          <S.Arrow
            disabled={selectedIndex === videos.length - 1}
            onClick={goNext}>
            Next&nbsp;
            <SVG icon={faArrowRight as SVGIcon} />
          </S.Arrow>
        </S.MobileNav>
      </S.MobileWrapper>

      <S.DesktopWrapper>
        <S.Content>
          <S.VideoBox>
            {!isOverlayVisible && isAboveTablet ? (
              <S.VideoPlayer
                autoPlay
                playsInline
                ref={videoRef}
                controls
                key={selectedTutorial.url}>
                <source src={selectedTutorial.url} type="video/mp4" />
                {t("video.not_support")}
              </S.VideoPlayer>
            ) : (
              <S.Thumbnail>
                <LogoWhite style={{ width: "200px", height: "auto" }} />
                <h1>{selectedTutorial.title}</h1>
              </S.Thumbnail>
            )}

            {isOverlayVisible && (
              <S.Overlay>
                <S.PlayButton onClick={handlePlayClick}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </S.PlayButton>
              </S.Overlay>
            )}
          </S.VideoBox>

          <Separator type="vertical" />

          <S.TutorialList>
            {videos.map((tutorial, index) => (
              <React.Fragment key={index}>
                <S.TutorialItem
                  active={index === selectedIndex}
                  onClick={() => handleVideoChange(index)}>
                  <S.TutorialText>{t(tutorial.titleKey)}</S.TutorialText>
                  <S.TutorialDuration>{tutorial.time}</S.TutorialDuration>
                </S.TutorialItem>
                {index < videos.length - 1 && <Separator type="horizontal" />}
              </React.Fragment>
            ))}
          </S.TutorialList>
        </S.Content>
      </S.DesktopWrapper>
    </S.Container>
  );
};

export default VideoTutorialSection;
